import { Camera, Mesh, PlaneGeometry, RawShaderMaterial, Scene, Vector2 } from "three";
import { SimulationMgr } from "./SimulationMgr";
import { vertex_1 } from "./shaders/shader";
import { EffectComposer, ShaderPass } from "three/examples/jsm/Addons.js";
import { RenderPass } from "three/examples/jsm/postprocessing/RenderPass.js";
import { globalParams } from "./global";
import { FilmPass } from "three/examples/jsm/postprocessing/FilmPass.js";

/**
 * 后期效果处理
 */
export class OutPutMgr {
    constructor(props) {
        this.props = props;
        this.init()
    }
    init() {
        this.simulation = new SimulationMgr({
            common: this.props.common,
            mouse: this.props.mouse,
            allowCursor: this.props.allowCursor
        });
        this.scene = new Scene();
        this.camera = new Camera();
        this.composer = null;
        this.mat = new RawShaderMaterial({
            vertexShader: vertex_1,
            fragmentShader: /*glsl */`precision highp float;
                uniform sampler2D velocity;
                uniform float colorScale;
                uniform float colorType;
                varying vec2 uv;

                void main(){
                    vec2 vel = texture2D(velocity, uv).xy;
                    float len = length(vel);
                    // vel = vel * 0.5 + 0.5;
                    float r; 
                    float g; 
                    float b; 
                    if(colorType == 1.0){
                        vel = vel * 0.5 + 0.5;
                        // vel = vel*10.0 + 15.0;
                        r = 0.75 * (1.0 - vel.x); 
                        g = vel.y * 0.85; 
                        b = vel.x * 1.0;
                    }else{
                        vel = vel * 0.5 + 0.5;
                        r = 0.35 * (1.0 - vel.x); 
                        g = vel.y * 0.85; 
                        b = vel.x * 1.0; 
                    }
                    // vec3 colorModel = vec3(0.53,0.27,0.17);//colorModel
                    vec3 colorModel2 = vec3(159.0/255.0,17.0/255.0,32.0/255.0);
                    // vec3 colorModel3 = vec3(181.0/255.0,57.0/255.0,70.0/255.0);//colorModel
                    // vec3 colorModel4 = vec3(208.0/255.0,149.0/255.0,152.0/255.0);//vec3(255.0/255.0,255.0/255.0,255.0/255.0);//
                    // vec3 colorModel5 = vec3(1.0/255.0,70.0/255.0,189.0/255.0);
                    vec3 color;
                    if(colorType == 1.0){
                        color = vec3(r,g,b);
                    }else{
                        color = colorModel2;//mix(colorModel, colorModel2, len);
                    }
                    // vec3 color = vec3(r*colorModel.x, g*colorModel.y, b*colorModel.z);
                    // vec3 color = vec3(0.35 *vel.x,0.85 *vel.y,0.35 *vel.x);
                    if(colorType == 1.0){
                        //浅色背景用固定色
                        color = mix(vec3(229.0/255.0, 228.0/255.0, 224.0/255.0), color, len);
                        //color = vec3(229.0/255.0, 228.0/255.0, 224.0/255.0);//mix(vec3(229.0/255.0, 228.0/255.0, 224.0/255.0), color, len);//color = mix(vec3(0.0), color * 2.0, len);    
                    }else{
                        color = mix(vec3(0.0), color, len);//color = mix(vec3(0.0), color * 2.0, len);
                    }
                    
                    vec4 fcolor = vec4(color,  1.0);//控制整体输出颜色vec4(color,  1.0);
                    
                    if(fcolor.r == 0.0 && fcolor.g == 0.0 && fcolor.b == 0.0){
                        fcolor.a = 0.0;
                    }
                    gl_FragColor = fcolor;//控制整体输出颜色vec4(color,  1.0);
            }`,
            uniforms: {
                velocity: {
                    value: this.simulation.fbos.vel_0.texture
                },
                boundarySpace: {
                    value: new Vector2()
                },
                diffuse: {
                    value: this.simulation.fbos.vel_0.texture
                },
                colorScale: {
                    value: 2
                },
                colorType:{
                    value:globalParams.options.colorType
                }
            }
        });
        this.output = new Mesh(new PlaneGeometry(2,2),this.mat);
        this.composer = new EffectComposer(this.props.common.renderer);
        this.composer.addPass(new RenderPass(this.scene,this.camera));
        this.blurPass = new ShaderPass({
            uniforms: {
                tDiffuse: {
                    value: null
                },
                resolution: {
                    value: new Vector2(this.props.common.width,this.props.common.height).multiplyScalar(window.devicePixelRatio)
                },
                blurSize: {
                    value: globalParams.blur_scale
                },
                blurDirection: {
                    value: globalParams.blur_direction
                },
                blurQuality: {
                    value: globalParams.blur_quality
                }
            },
            vertexShader: `
                varying vec2 v_uv;
                void main() {
                    v_uv = uv;
                    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
                }`,
            fragmentShader: /*glsl */`
                uniform sampler2D tDiffuse;
                uniform vec2 resolution;
                uniform float blurSize;
                uniform float blurDirection;
                uniform float blurQuality;

                varying vec2 v_uv;

                vec4 blur(sampler2D tex){
                    const float PI2 = 6.28318530718; // Pi*2
                    
                    // BLUR SETTINGS {{{
                    // const float directions = blurDirection; // 16.0; // BLUR DIRECTIONS (Default 16.0 - More is better but slower)
                    // const float quality = blurQuality; // 3.0; // BLUR QUALITY (Default 3.0 - More is better but slower)
                    // BLUR SETTINGS }}}
                
                    vec2 radius = blurSize/resolution;
                    
                    // Normalized pixel coordinates (from 0 to 1)
                    vec2 uv = gl_FragCoord.xy/resolution;
                    // Pixel colour
                    vec4 color = texture2D(tex, uv);
                    
                    // Blur calculations
                    int count = 1;
                    for( float theta=0.0; theta<PI2; theta+=PI2/blurDirection)
                    {
                        vec2 dir = vec2(cos(theta), sin(theta)) * radius;
                        for(float i=1.0/blurQuality; i<=1.0; i+=1.0/blurQuality)
                        {
                            color += texture2D( tex, uv+dir*i);	
                            count++;
                        }
                    }
                
                    color /= float(count);
                
                    return color;   
                }
                
                void main (void)
                {
                    gl_FragColor = blur(tDiffuse); 
                }`
        });
        this.blurPass.renderToScreen = true;
        this.composer.addPass(this.blurPass);
        this.film_grain = globalParams.options.film_grain;
        this.effectFilm = new FilmPass(this.film_grain,false);
        this.composer.addPass(this.effectFilm);
        this.scene.add(this.output);
    }

    hideEffect(){
        this.effectFilm.enabled = false;
        // this.blurPass.enabled = false;
    }
    showEffect(){
        this.effectFilm.enabled = true;
        this.blurPass.enabled = true;
    }
    addScene(e) {
        this.scene.add(e);
    }
    resize() {
        this.simulation.resize();
    }
    render() {
        this.common.renderer.setRenderTarget(null);
        this.common.renderer.render(this.scene, this.camera);
    }
    update() {
        this.mat.uniforms.colorType.value = globalParams.options.colorType;
        this.simulation.update();
        this.composer.render();
        this.film_grain = globalParams.options.film_grain;
        this.effectFilm.uniforms.intensity.value = this.film_grain;
        this.blurPass.uniforms.blurSize.value = globalParams.options.blur_scale;
        this.blurPass.uniforms.blurDirection.value = globalParams.options.blur_direction;
        this.blurPass.uniforms.blurQuality.value = globalParams.options.blur_quality;
    }
}